/* eslint-disable */
export default {
  meetingTitle: 'Reunión de {extensionName}',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
